import type { ReactNode } from 'react';
import { DesignSystemScope } from '../theme/DesignSystemScope.tsx';
import { useDesignSystemEnabled } from '../theme/useDesignSystemEnabled.ts';
import { TOGGLE_BUTTON_GROUP_FIELD_DESIGN_SYSTEM_KEYS } from './toggleButtonGroupFieldDesignSystem.ts';

type ToggleButtonGroupDesignSystemScopeProps = {
  children: ReactNode;
};

// For a raw `ToggleButtonGroup` that keeps its own `onChange`; `ToggleButtonGroupField` already scopes itself.
export const ToggleButtonGroupDesignSystemScope = ({
  children,
}: ToggleButtonGroupDesignSystemScopeProps): ReactNode => {
  const isDesignSystem = useDesignSystemEnabled('toggleButtonGroupField');

  return isDesignSystem ? (
    <DesignSystemScope keys={TOGGLE_BUTTON_GROUP_FIELD_DESIGN_SYSTEM_KEYS}>{children}</DesignSystemScope>
  ) : (
    children
  );
};
